import { GAME_IDS } from "./types.js";

const games = new Map();

export function registerGame(plugin) {
  if (!plugin?.id) throw new Error("Game plugin requires id");
  games.set(plugin.id, plugin);
}

export function getGame(id) {
  return games.get(id) || null;
}

export function listGames() {
  return [...games.values()];
}

export function getGamePlugin() {
  return getGame(GAME_IDS.FAVORITE_DANCES);
}
